import React, { useEffect, useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';

const BackToTop = ({ offset = 300, title }) => {
    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = useCallback(() => {
        setIsVisible(window.scrollY > offset);
    }, [offset]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);

    if (!isVisible) return null;

    return (
        <button
        className="back-to-top"
        onClick={scrollToTop}
        aria-label="Back to Top"
        >
            {title ? 'Back to Top' : '' }
            <FontAwesomeIcon icon={faArrowUp} />
        </button>
    );
};

export default BackToTop;
